import React from "react";
import moment from "moment";
import "react-multi-date-picker/styles/layouts/mobile.css";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import {
  DataDilogLayout,
  TdItem,
} from "../../../Objects/interfaces/AppInterface";
import Functions from "../../../Helpers/Functions";
import TableTbodyLayout from "../../../Components/Table/TableTbodyLayout";
import ApiService from "../../../Services/ApiService";
import { Subject } from "../../../Objects/models/Subject";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import KeyboardArrowUpTwoToneIcon from "@mui/icons-material/KeyboardArrowUpTwoTone";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import useTailwindBrand from "../../../Theme/useTailwindBrand";
import { useState } from "react";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ModeSharpIcon from "@mui/icons-material/ModeSharp";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { lisActionInterface } from "../../../Objects/interfaces/AppInterface";
import { Menu, MenuItem, IconButton } from "@mui/material";
import DialogLayout from "../../../Components/DialogLayout";
import DetailCoursClient from "./DetailCoursClient";
import { renderContentTd } from "../../../Utils/Function";
import "moment/locale/fr";
import FormEditCourseClient from "./FormEditCourseClient";
import PunctualCourseRepository from "../../../Repositories/PunctualCourseRepository";
import { PunctualCourseDashboardUpdate } from "../../../Objects/models/PunctualCourseDashboardUpdate";
import FetchCoursProposals from "./FetchCoursProposals";
import Swal from "sweetalert2";
import { useCourseProposals } from "./UseCourseProposals";

moment.locale("fr");

const UserCourses = (props: any) => {
  let timerInterval: any;
  const {
    punctual,
    toggleRow,
    activeRow,
    teachr,
    load,
    setLoad,
    isHome,
    isCoursePass,
    activeTab,
  } = props;

  const [subjectsMap, setSubjectsMap] = React.useState<{
    [key: number]: string;
  }>({});

  const [option, setOption] = useState({
    showDetail: false,
    edit: false,
    deletes: false,
    isOver: false,
  });

  const [editData, setEditData] = useState<{
    startTime: Date;
    endTime: Date;
    duration: number;
    isRemote: boolean;
    infos: string;
    subject?: Subject | null;
  }>({
    startTime: punctual.startDatetime
      ? new Date(punctual.startDatetime)
      : new Date(),
    endTime: punctual.endDatetime ? new Date(punctual.endDatetime) : new Date(),
    duration: Number(punctual.duration / 2) || 1,
    isRemote: punctual.isRemote,
    infos: punctual.infos,
    subject: null,
  });

  const [courseDate, setCourseDate] = useState(
    new Date(punctual.startDatetime)
  );

  React.useEffect(() => {
    if (option.edit) {
      setCourseDate(editData.startTime || new Date(punctual.startDatetime));
    }
  }, [option.edit, editData.startTime, punctual.startDatetime]);

  const { classes } = useTailwindBrand();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  React.useEffect(() => {
    const fetchSubjects = async () => {
      const response = await ApiService.get("/subjects");
      const subjectsArray: Subject[] = response["hydra:member"] || [];
      const map: { [key: number]: string } = {};
      subjectsArray.forEach((s: Subject) => {
        map[s.id] = s.fr_FR;
      });
      setSubjectsMap(map);
    };
    fetchSubjects();
  }, []);

  // const subtitle = "Proposal des cours";
  const startDate = moment(punctual?.startDatetime).format("DD MMM YYYY");
  const startTime = moment(punctual?.startDatetime).format("HH:mm");
  const endTime = moment(punctual?.endDatetime).format("HH:mm");

  const handleDurationChange = (newDuration: number) => {
    setEditData((prev) => {
      const newEndTime = new Date(
        prev.startTime.getTime() + newDuration * 60 * 60 * 1000
      );
      return { ...prev, duration: newDuration, endTime: newEndTime };
    });
  };

  const handleShowDetail = () => setOption({ ...option, showDetail: true });

  const handleCloseShowDetail = () =>
    setOption((prev) => ({ ...prev, showDetail: false }));

  const handleEdit = () => {
    const start = new Date(punctual.startDatetime);
    const end = new Date(punctual.endDatetime);

    const durationInHours =
      (end.getTime() - start.getTime()) / (1000 * 60 * 60);

    const subjectObject = subjectsMap[punctual.subjectAsked_id]
      ? {
        id: punctual.subjectAsked_id,
        fr_FR: subjectsMap[punctual.subjectAsked_id],
      }
      : punctual.subject || null;

    setEditData({
      startTime: start,
      endTime: end,
      duration: durationInHours,
      subject: subjectObject,
      isRemote: punctual.isRemote,
      infos: punctual.infos,
    });

    setOption({ ...option, edit: true });
  };

  const handleDelete = () => {
    setOption({ ...option, deletes: true });
  };

  const courseStartDate = new Date(punctual.startDatetime);

  const formatDate = (date: any) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("fr-FR", options).replace(".", "");
  };

  const currentClient = teachr;

  const formattedTime = startTime.replace(":", "h");

  const dataDialogDetail: DataDilogLayout = {
    title: `Détails du cours`,
    text: (
      <p>
        Voici les détails du cours de{" "}
        <strong>{subjectsMap[punctual.subjectAsked_id]}</strong>, prévu pour le{" "}
        <strong>
          {formatDate(courseStartDate)} à {formattedTime}
        </strong>
        . Retrouvez ci-dessous toutes les informations associées à ce cours.
      </p>
    ),
    valid: "Supprimer",
    cancel: "Annuler",
    open: option.showDetail,
    load: load,
    children: (
      <div className="w-[900px] max-w-full">
        <DetailCoursClient
          activeTab={activeTab}
          duration={editData.duration}
          eleve={currentClient.firstName}
          matiere={subjectsMap[punctual.subjectAsked_id] || "-"}
          startDatetime={punctual.startDatetime}
          endDatetime={punctual.endDatetime}
          duree={Functions.renderDuration(punctual.duration)}
          format={punctual.isRemote ? "En ligne" : "À domicile"}
          remuneration={punctual.remuneration || "-"}
          acompte={punctual.acompte || "-"}
          reste={punctual.reste || "-"}
          statut={punctual.status || "-"}
          infos={punctual.infos}
          proofDeposit={punctual.proofDeposit}
          punctual={punctual.id}
          isUrgent={punctual.isCourseInTheHour}
          onOpenProposal={handleCloseShowDetail}
          clientID={currentClient}
        />
      </div>
    ),
    customDialogActions: "hidden",
    handleCloseIcon: handleCloseShowDetail,
    handleClose: handleCloseShowDetail,
  };

  const [loadProposals, setLoadProposals] = useState(false);

  const proposals = useCourseProposals(
    punctual.id,
    loadProposals,
    setLoadProposals
  );

  const getStatusLabel = () => {
    if (punctual.upcomingCourses) return "En cours";
    if (activeTab === "historic") return 'Cours terminé';
    if (activeTab === "pending" && proposals.length > 0) return "En proposition";
    return "En attente";
  };

  const status = getStatusLabel();

  const dataDialogUpdate: DataDilogLayout = {
    title: `Modification du cours`,
    text: (
      <p>
        Vous allez modifier le cours de{" "}
        <strong>{subjectsMap[punctual.subjectAsked_id]}</strong>, prévu pour le
        du <strong>{formatDate(courseStartDate)}</strong>. Afin de procéder à
        cette modification du cours, merci de bien vouloir compléter ou ajuster
        les champs ci-dessous.
      </p>
    ),
    open: option.edit,
    handleClose: () => setOption({ ...option, edit: false }),
    handleCloseIcon: () => setOption({ ...option, edit: false }),
    valid: "Modifier",
    cancel: "Annuler",
    handleSubmit: async () => {
      setLoad(true);
      try {
        const start = editData.startTime;
        if (!start) {
          console.error("Start date is undefined!");
          setLoad(false);
          return;
        }
        const durationHours = Number(editData.duration) || 1;

        const end = new Date(
          start.getTime() + (Number(editData.duration) || 1) * 60 * 60 * 1000
        );

        const updatedCourse = new PunctualCourseDashboardUpdate(
          start,
          end,
          durationHours.toFixed(2)
        );

        const payload = {
          ...updatedCourse,
          duration: (durationHours * 2).toString(),
          subjectAskedId: editData.subject?.id,
          infos: editData.infos,
          isRemote: editData.isRemote,
        };

        await PunctualCourseRepository.updatePunctualCourseByTeachr(
          punctual.id!,
          payload
        );

        setCourseDate(start);
        punctual.startDatetime = start;

        setEditData((prev) => ({
          ...prev,
          startTime: start,
          endTime: end,
          duration: Number(prev.duration),
        }));
        Swal.fire({
          icon: "success",
          title: "Cours Modifié",
          text: "  Votre cours a bien été modifié",
          timer: 5000,
          willClose: () => {
            clearInterval(timerInterval);
            setLoad(false);
          },
        });
        setOption({ ...option, edit: false });
        setLoad(false);

        props.refetchCourses?.();
      } catch (error) {
        console.error("Failed to update punctual course:", error);
      } finally {
        setLoad(false);
      }
    },
    children: (
      <div className="">
        <FormEditCourseClient
          status={status}
          activeTab={activeTab}
          valueDate={courseDate}
          setDate={(value) => {
            const newDate =
              typeof value === "function"
                ? (value as (prev: Date) => Date)(courseDate)
                : value;
            setCourseDate(newDate);
            setEditData((prev: any) => ({ ...prev, startTime: newDate }));
          }}
          setEditData={setEditData}
          editData={editData}
          isPunctualMonth={punctual.frequency !== 1}
          handleDurationChange={handleDurationChange}
          courseType={punctual.isCourseInTheHour}
        />
      </div>
    ),
  };

  const dataDialogDelete: DataDilogLayout = {
    title: `Suppression du cours`,
    text: (
      <p>
        Vous êtes sur le point de supprimer le cours du{" "}
        <strong>{formatDate(courseStartDate)}</strong>. Cliquez sur{" "}
        <strong>Supprimer</strong> pour confirmer ou
        <strong> Annuler</strong> pour abandonner.
      </p>
    ),
    valid: "Supprimer",
    cancel: "Annuler",
    open: option.deletes,
    load: load,
    children: "",
    handleSubmit: async () => {
      if (!punctual?.id) {
        console.error("Cannot delete: client course ID is missing!", punctual);
        return;
      }

      try {
        await PunctualCourseRepository.deletePunctualCourse(punctual);

        Swal.fire({
          icon: "success",
          title: "Cours supprimé",
          text: "  Votre cours a bien été supprimé. Il ne sera pas déclaré et a disparu de votre liste de cours prévus.",
          timer: 5000,
          willClose: () => {
            clearInterval(timerInterval);
            setLoad(false);
          },
        });

        setOption((prev) => ({ ...prev, deletes: false }));

        props.refetchCourses?.();
      } catch (error) {
        console.error("Failed to delete client course:", error);
      } finally {
        setLoad(false);
      }
    },
    handleClose: () => setOption((prev) => ({ ...prev, deletes: false })),
    handleCloseIcon: () => setOption((prev) => ({ ...prev, deletes: false })),
  };

  const listItems: lisActionInterface[] = [];

  listItems.push({
    title: "Consulter",
    icon: (
      <RemoveRedEyeOutlinedIcon
        fontSize="small"
        className={`${classes.primaryText}`}
      />
    ),
    funct: handleShowDetail,
    class: "",
  });

  if (isCoursePass && !punctual.pastPonctualCourseList) {
    listItems.push(
      {
        title: "Modifier",
        icon: (
          <ModeSharpIcon
            fontSize="small"
            className={`${classes.primaryText}`}
          />
        ),
        funct: handleEdit,
        class: "",
      },
      {
        title: "Supprimer",
        icon: (
          <DeleteOutlinedIcon
            fontSize="small"
            className={`${classes.primaryText}`}
          />
        ),
        funct: handleDelete,
        class: "",
      }
    );
  }

  const courseStartDate2 = new Date(punctual.startDatetime);
  const now = new Date();
  const isCoursePassed = courseStartDate2 < now;

  const courseDateCellContent = (
    <div className="flex flex-col">
      <span>{startDate}</span>
      {activeTab === "pending" && isCoursePassed && (
        <span className="text-red-600 font-bold text-sm">
          L'heure de cours est déjà passé
          <br />
          <small>Modifiez la date pour conserver le cours</small>
        </span>
      )}
    </div>
  );


  const datas: TdItem[] = [
    {
      title: courseDateCellContent,
      classTrTd: "px-4 py-2 border-l rounded-l-md",
    },
    {
      title: `${startTime} à ${endTime}`,
      classTrTd: `${isHome ? "hidden" : ""} px-4 py-2`,
    },
    {
      title: renderContentTd(Functions.renderDuration(punctual.duration), true),
      classTrTd: "px-4 py-2",
    },
    {
      title: `${subjectsMap[punctual.subjectAsked_id] || "-"}`,
      classTrTd: `${isHome ? "hidden" : ""} px-4 py-2`,
    },
    {
      title: renderContentTd(
        getStatusLabel(),
        false,
        undefined,
        <PendingOutlinedIcon className="w-5 h-5 mr-2 text-first" />
      ),
      classTrTd: "px-4 py-2",
    },
    {
      title: punctual.isRemote ? "En ligne" : "À domicile",
      classTrTd: "px-6 py-2",
    },
    {
      title: punctual.isCourseInTheHour ? "Cours en urgence" : "Cours ponctuel",
      classTrTd: "px-6 py-2",
    },
    {
      title: (
        <div className="flex">
          <IconButton
            size="small"
            onClick={handleClick}
            className={`${classes.primaryText}`}
          >
            <MoreHorizSharpIcon />
          </IconButton>
          <IconButton size="small" onClick={() => toggleRow(punctual.id)}>
            {activeRow === punctual.id ? (
              <KeyboardArrowUpTwoToneIcon
                className={`${classes.primaryText}`}
              />
            ) : (
              <KeyboardArrowDownTwoToneIcon
                className={`${classes.primaryText}`}
              />
            )}
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            {listItems.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => {
                  item.funct?.();
                  handleClose();
                }}
              >
                {item.icon}
                <span className="ml-2">{item.title}</span>
              </MenuItem>
            ))}
          </Menu>
        </div>
      ),
      classTrTd: `${isHome ? "hidden" : ""} py-2 sticky right-0 z-10 bg-white`,
    },
  ];

  return (
    <>
      <TableTbodyLayout
        isCollapse={
          punctual.upcomingCourses || activeTab === "historic" ? false : true
        }
        subtitle={punctual.upcomingCourses ? "" : "Proposition des cours"}
        toggleRow={toggleRow}
        activeRow={activeRow}
        datas={datas}
        id={punctual.id}
        colSpan={datas.length}
        subChild={
          punctual.upcomingCourses === true ? null : (
            <FetchCoursProposals
              duration={editData.duration}
              punctualId={punctual.id}
              toggleRow={toggleRow}
              activeRow={activeRow}
              clientId={currentClient?.id}
              load={loadProposals}
              setLoad={setLoadProposals}
              isHome={isHome}
              refetchCourses={props.refetchCourses}
            />
          )
        }
      />
      <DialogLayout {...dataDialogDetail} />
      <DialogLayout {...dataDialogUpdate} />
      <DialogLayout {...dataDialogDelete} />
    </>
  );
};

export default UserCourses;
